import jwt from 'jsonwebtoken';

export const isJwtWithinExpiryTime = (token: string = '') => {
  try {
    const decodedToken = jwt.decode(token);
    const currentTime = Date.now();
    if (typeof decodedToken === 'string') {
      return false;
    }
    const tokenIssuedAt = decodedToken?.iat ? decodedToken.iat * 1000 : 0;
    const tokenExpiry = decodedToken?.exp ? decodedToken.exp * 1000 : 0;

    // Check that the client's current time is trustworthy before checking if the
    // token has expired (make sure it is at least later than the token's issue
    // time).
    if (tokenIssuedAt < currentTime) {
      if (currentTime >= tokenExpiry) {
        return false;
      }
    } else {
      return false;
    }
  } catch (err) {
    return false;
  }
  return true;
};
